<template>
  <div>
    <v-breadcrumbs
      :home-route="{name: 'organisation-dashboard'}"
      :breadcrumbs="crumbs"
    />
    <div>
      <v-dashboard-tabs/>
    </div>
    <div v-if="research">
      <v-research-options-bar
        @filter="refreshData"
      />
      <div v-if="tab === 'dashboard'">
        <v-research-dashboard-tab/>
      </div>
      <div v-if="tab === 'items'">
        <div class="row">
          <div
            v-for="researchItem in researchItems"
            :key="researchItem.id"
            class="col-12 col-xl-6 mb-3"
          >
            <v-item-data
              :research="research"
              :research-item="researchItem"
            />
          </div>
        </div>
      </div>
      <div v-if="tab === 'table'">
        <v-answer-list-tab/>
      </div>
      <div v-if="tab === 'general'">
        <div class="row">
          <div class="col-md-4">
            <v-research-general-info
              :research="research"
            />
          </div>
          <div class="col-md-8">
            <v-research-structure-view
              :research="research"
              :research-items="researchItems || []"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="loadingResearch || loadingResearchItems" class="pt-5 text-center">
      <div class="mb-3">{{ $t('sentence.please_wait_data_loaded') }}</div>
      <v-loader/>
    </div>
  </div>
</template>

<script>
import AnswerListTab from '@/organisation/components/research/AnswerListTab.vue';
import Breadcrumbs from '@/common/components/Breadcrumbs.vue';
import DashboardTabs from '@/organisation/components/dashboard/DashboardTabs.vue';
import ItemData from '@/organisation/components/research/ItemData.vue';
import Loader from '@/common/components/Loader.vue';
import ResearchDashboardTab from '@/organisation/components/research/ResearchDashboardTab.vue';
import ResearchGeneralInfo from '@/common/components/research/ResearchGeneralInfo.vue';
import ResearchOptionsBar from '@/organisation/components/research/ResearchOptionsBar.vue';
import ResearchStructureView from '@/common/components/research/ResearchStructureView.vue';
import { mapGetters } from 'vuex';
import { CLICKABLE_STATUSES } from '@/organisation/services/researches';
import { pageNotFound } from '@/common/utils/notify';


export default {
  name: 'ResearchDashboardView',
  components: {
    'v-dashboard-tabs': DashboardTabs,
    'v-answer-list-tab': AnswerListTab,
    'v-breadcrumbs': Breadcrumbs,
    'v-item-data': ItemData,
    'v-loader': Loader,
    'v-research-dashboard-tab': ResearchDashboardTab,
    'v-research-general-info': ResearchGeneralInfo,
    'v-research-options-bar': ResearchOptionsBar,
    'v-research-structure-view': ResearchStructureView,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters('researches', [
      'data',
      'filters',
      'loadingResearch',
      'loadingResearchItems',
      'research',
      'researchItems',
    ]),
    crumbs() {
      return [
        {
          title: this.$tc('word.research', 2),
          routeTo: { name: 'organisation-research-list' },
        },
        {
          title: this.research ? this.research.title : '...',
        },
      ];
    },
    tab() {
      return this.$route.query.tab ? this.$route.query.tab : 'dashboard';
    },
  },
  methods: {
    async fetchResearch() {
      await this.$store.dispatch('researches/fetchResearch', this.$route.params.uuid);
      if (!this.research || !CLICKABLE_STATUSES.includes(this.research.status)) {
        pageNotFound();
        await this.$router.push({ name: 'organisation-research-list' });
        return;
      }
      if (this.research.status === 'draft') {
        await this.$router.push({ name: 'organisation-research-edit', params: { uuid: this.research.uuid } });
      }
    },
    async fetchResearchItems() {
      await this.$store.dispatch('researches/fetchResearchItems', this.$route.params.uuid);
    },
    async fetchResearchReviewSessions() {
      await this.$store.dispatch('researches/fetchResearchReviewSessions', this.$route.params.uuid);
    },
    async fetchResearchStats() {
      await this.$store.dispatch('researches/fetchResearchStatistics', this.$route.params.uuid);
    },
    refreshData() {
      this.fetchResearchReviewSessions();
      this.fetchResearchStats();
    },
  },
  created() {
    if (!this.research || this.research.uuid !== this.$route.params.uuid) {
      this.$store.commit('researches/resetFilters');
      this.$store.commit('researches/setResearchStatistics', {});
      this.$store.commit('researches/setResearchReviewSessions', []);
      this.fetchResearch();
      this.fetchResearchItems();
      this.refreshData();
    }
  },
};
</script>
